import {gql} from '@apollo/client';

import {MeasurementUnitFragment} from 'constants/MeasurementConstants';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const PLATE_RECORD_HYDRATED_DATA_QUERY = gql`
  query PlateRecordHydratedDataQuery(
    $bioentityIds: [StrictString]!
    $storableIds: [StrictString]!
    $unitIds: [StrictString!]!
    $unitVersionNumbers: [StrictInt!]
    $testOrderIds: [StrictString!]!
  ) @skipAudit @engComponent(name: INVENTORY) {
    bioentities(ids: $bioentityIds) {
      ... on RegistryItemInterface {
        id
        name
        tagSchema {
          id
          iconId
        }
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
    storables(ids: $storableIds) {
      ... on StorableInterface {
        id
        name
        storableSchema {
          id
          iconId
        }
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
    units(ids: $unitIds, versionNumbers: $unitVersionNumbers) {
      ...MeasurementUnit
    }
    testOrders(ids: $testOrderIds) {
      ... on TestOrderNode {
        id
        name
        dilutionFactor
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${MeasurementUnitFragment.fragment}
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
